module.exports = __webpack_public_path__ + "static/media/braeanneori.c84d2b47.jpeg";